import { Injectable } from '@angular/core';

import { MainConfig } from '../main-config';
import { Locale } from '../models';

@Injectable()
export class LocaleDataService {
  private localeStorageKey = 'intl_locale';
  private localesAvailable: Array<Locale>;
  private defaultLocaleCode: string;
  private currentLocale: Locale;

  constructor(private mainConfig: MainConfig) {
    this.localesAvailable = this.mainConfig.localesAvailable;
    this.defaultLocaleCode = this.mainConfig.defaultLocaleCode;

    if (localStorage.getItem(this.localeStorageKey) === null) {
      localStorage.setItem(this.localeStorageKey, this.defaultLocaleCode);
    }

    this.currentLocale = this.getCurrentLocale();
  }

  getLocalesAvailable(): Array<Locale> {
    return this.localesAvailable;
  }

  getDefaultLocale(): Locale {
    return this.localesAvailable.filter(item => item.code == this.defaultLocaleCode).shift();
  }

  getCurrentLocale(): Locale {
    const code = localStorage.getItem(this.localeStorageKey);

    return this.localesAvailable.filter(item => item.code == code).shift();
  }

  setLocale(code: string): void {
    if (this.localesAvailable.map(item => item.code).indexOf(code) == -1) {
      console.log(`El idioma "${code}" no esta entre los idiomas disponibles`);
      return;
    }

    localStorage.setItem(this.localeStorageKey, code);
  }

  getLocale(): string {
    return !this.currentLocale
      ? localStorage.getItem(this.localeStorageKey)
      : this.currentLocale.code;
    
  }

  getLocaleName(code: string): string {
    const locale = this.localesAvailable.find(item => item.code === code);
    return locale ? locale.name : '';
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/services/locale-data.service.ts